import { FIRST_FETCH_ITEMS } from "src/constants/constants";

export const getLoadMoreItems = () => {
  const storedValue = localStorage.getItem("loadMoreSize");
  return storedValue ? parseInt(storedValue, 10) : FIRST_FETCH_ITEMS;
};
